import i18n from "../../i18n";
import React from "react";
import { Stack, Text } from "@mantine/core";
import McaStepFileList from "./McaStepFileList";
import { collectMcaStepFiles } from "./mcaStepFiles";

const copyNote = (request) => {
  if (request?.action === "DELETE") {
    return "These files stay on this request.";
  }
  if (request?.status === "APPROVED") {
    return "Copied to the entity Files tab.";
  }
  return "These files are copied to the entity Files tab when the request is fully approved.";
};

const McaRequestFiles = ({ request }) => {
  const files = collectMcaStepFiles(request);
  if (!files.length) {
    return (
      <Text size="sm" color="dimmed">
        {i18n.t("No files uploaded")}
      </Text>
    );
  }

  return (
    <Stack spacing="sm">
      <Text size="sm" color="dimmed">
        {i18n.t(copyNote(request))}
      </Text>
      <McaStepFileList files={files} showMeta />
    </Stack>
  );
};

export default McaRequestFiles;
